/**
 * Created by gilk on 12/03/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Link = require("ui/link/Link");
    var template = require("manager-templates/data-sources/conversation-sources/brand-app/brandAppAdvantagesView.tmpl");
    var LEResourceResolver = require("leResourceResolver");


    var BrandAppAdvantagesView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        BrandAppAdvantagesView = Marionette.ItemView.extend({
            template : template,
            ui: {
                iosLinkContainer: ".ios-link",
                androidLinkContainer: ".android-link"
            },
            uiComponents: {
                iosLink: {
                    type: Link,
                    options: {
                        el: "view.ui.iosLinkContainer",
                        text: LE.translator.translate("LEManager.dataSources.conversationSources.brandApp.header.advantage4.iosDocumentation"),
                        href: LEResourceResolver.getUrl(LEResourceResolver.apiResources.LivepersonInc.IOSSDK)
                    }
                },
                androidLink: {
                    type: Link,
                    options: {
                        el: "view.ui.androidLinkContainer",
                        text: LE.translator.translate("LEManager.dataSources.conversationSources.brandApp.header.advantage4.androidDocumentation"),
                        href: LEResourceResolver.getUrl(LEResourceResolver.apiResources.LivepersonInc.AndroidSDK)
                    }
                }
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return BrandAppAdvantagesView;
});
